import React from "react";
import "./Policies.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-wrapper">
      <div className="policy-container">
        <div className="policy-header">
          <h1>Privacy Policy</h1>
          <p>Effective Date: January 1, 2025</p>
        </div>

        <div className="policy-content">
          <p>
            At HexaPlay, we value the privacy of our customers and visitors.
            This Privacy Policy explains how we collect, use, and protect your
            personal information when you use our website or services.
          </p>

          <h2>1. Information We Collect</h2>

          <h3>Personal Information</h3>
          <ul>
            <li>Name</li>
            <li>Phone number</li>
            <li>Email address</li>
            <li>Booking details</li>
            <li>Event details (if applicable)</li>
          </ul>

          <h3>Non-Personal Information</h3>
          <ul>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Device information</li>
            <li>Pages visited</li>
            <li>Time spent on the website</li>
          </ul>

          <p>
            This data helps us improve our services and enhance user experience.
          </p>

          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>Process bookings and reservations</li>
            <li>Manage gaming or theatre sessions</li>
            <li>Provide customer support</li>
            <li>Send booking confirmations</li>
            <li>Improve our website and services</li>
            <li>
              Communicate promotional offers or updates (only if consent is
              given)
            </li>
          </ul>

          <h2>3. Cookies</h2>
          <p>
            Our website may use cookies to improve functionality and user
            experience.
          </p>
          <ul>
            <li>Remember user preferences</li>
            <li>Analyze website traffic</li>
            <li>Optimize performance</li>
          </ul>
          <p>
            Users may disable cookies through their browser settings.
          </p>

          <h2>4. Third-Party Services</h2>
          <p>
            HexaPlay may use third-party services such as:
          </p>
          <ul>
            <li>Payment gateways</li>
            <li>Advertising platforms</li>
            <li>Website analytics tools</li>
          </ul>
          <p>
            These services may collect certain information according to their
            own privacy policies.
          </p>

          <h2>5. Data Protection Rights</h2>
          <ul>
            <li>Access to personal data</li>
            <li>Correction of incorrect data</li>
            <li>Deletion of personal data</li>
            <li>Restriction of data processing</li>
          </ul>
          <p>
            Requests can be submitted through our contact information.
          </p>

          <h2>6. Children's Information</h2>
          <p>
            Protecting children’s privacy is important to us. HexaPlay does not
            knowingly collect personal information from children under 13 years
            of age without parental consent.
          </p>

          <h2>7. Updates to Privacy Policy</h2>
          <p>
            HexaPlay may update this Privacy Policy periodically. Changes will
            be posted on this page.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;